import { useClientSessionOmitter } from '@shared/hooks/useClientSessionOmitter';

export const useEndMashboardSession = () => {
  const { endMashboardSession } = useClientSessionOmitter();

  return endMashboardSession;
};
